module.exports = __webpack_public_path__ + "05_short_yellow.386273a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/05_short_yellow.png
// module id = upsi
// module chunks = 0